(function () {
  try {
    var MENU = 'modal-main-menu';
    var CART = 'modal-cart';
    var CLICK_WAIT = 4000;
    var SUBMIT_WAIT = 6000;
    var pendingClick = null;
    var pendingSubmit = null;
    var clickTimer = 0;
    var submitTimer = 0;
    var mo = null;
    var dclAt = document.readyState === 'complete' ? 1 : 0;
    var dclDone = document.readyState !== 'loading';
    var SYNC_WAIT = 6000;
    var earlyPick = null;
    var sync = 'none';

    function warn(err) {
      try { console.warn('TWRD: early-tap', err); } catch (_) {}
    }
    function isBound(id) {
      var d = document.getElementById(id);
      return !!d && d.getAttribute('aria-modal') === 'true';
    }
    function formsReady() {
      var ids = document.querySelectorAll('product-form input[name="id"]');
      for (var i = 0; i < ids.length; i++) {
        if (ids[i].disabled) return false;
      }
      return true;
    }
    function allBound() {
      var done = document.readyState === 'complete';
      var menuOk = isBound(MENU) || (done && !document.getElementById(MENU));
      var cartOk = isBound(CART) || (done && !document.getElementById(CART));
      return menuOk && cartOk && formsReady();
    }

    function onDcl() {
      dclAt = Date.now();
      /* Lad de andre DOMContentLoaded-lyttere (fx Choose size) koere foerst. */
      setTimeout(function () { dclDone = true; tick(); }, 0);
    }
    /* Scripts med defer og module koerer foer DOMContentLoaded. Giv dem plads foer vi opgiver. */
    function stillLoading() {
      return !dclAt || Date.now() - dclAt < 1500;
    }

    function teardown() {
      window.removeEventListener('click', onClick, true);
      window.removeEventListener('submit', onSubmit, true);
      window.removeEventListener('click', onPick, true);
      document.removeEventListener('DOMContentLoaded', onDcl);
      window.removeEventListener('load', tick);
      if (mo) { mo.disconnect(); mo = null; }
      clearTimeout(clickTimer);
      clearTimeout(submitTimer);
    }

    function replayClick(el) {
      var ev = new MouseEvent('click', { bubbles: true, cancelable: true, view: window });
      ev.__twrdReplay = true;
      el.dispatchEvent(ev);
    }

    function tryReplayClick() {
      var p = pendingClick;
      if (!p || document.readyState === 'loading' || !isBound(p.id)) return;
      pendingClick = null;
      requestAnimationFrame(function () {
        clearTimeout(clickTimer);
        try { replayClick(p.el); } catch (err) { warn(err); }
        tick();
      });
    }

    function giveUpClick(p) {
      if (pendingClick !== p) return;
      /* Siden henter stadig scripts (langsom telefon): vent, det er ikke en fejl endnu. */
      if (stillLoading()) {
        clickTimer = setTimeout(function () { giveUpClick(p); }, 500);
        return;
      }
      pendingClick = null;
      try {
        var href = p.el.tagName === 'A' ? p.el.getAttribute('href') : '';
        if (href && href !== '#') location.href = p.el.href;
      } catch (err) { warn(err); }
      tick();
    }

    function formOf(p) {
      var f = p.formId ? document.getElementById(p.formId) : null;
      return f && f.closest && f.closest('product-form') ? f : p.form;
    }

    function submitForm(p) {
      var form = formOf(p);
      form.__twrdReplay = true;
      try {
        var sub = p.submitter && form.contains(p.submitter) ? p.submitter : undefined;
        try { form.requestSubmit(sub); } catch (_) { form.requestSubmit(); }
      } finally {
        form.__twrdReplay = false;
      }
    }

    /* Et tidligt valg (foer variant-radios var klar) naaede ikke det skjulte variant-id. Send det igen og vent paa svaret.
       Svaret tjekkes: varianten skal have den valgte vaerdi. Temaets egen render kan vinde, saa vi proever op til 3 gange. */
    function findVr() {
      return document.querySelector('.product-single variant-radios, .product-single__box variant-radios');
    }
    function startSync() {
      if (sync !== 'none' || !earlyPick) return;
      var first = findVr();
      if (!first || !customElements.get('variant-radios')) return;
      sync = 'pending';
      var tries = 0;
      var done = false;
      var timer = 0;
      function finish(ok) {
        if (done) return;
        done = true;
        clearTimeout(timer);
        document.removeEventListener('on:variant:change', onVariant, true);
        sync = ok ? 'done' : 'failed';
        tick();
      }
      function matches(v) {
        return !!v && Object.prototype.toString.call(v.options) === '[object Array]' && v.options.indexOf(earlyPick.value) > -1;
      }
      function attempt() {
        if (done) return;
        tries += 1;
        var vr = findVr();
        var input = null;
        var ins = vr ? vr.querySelectorAll('input[type="radio"]') : [];
        for (var i = 0; i < ins.length; i++) {
          if (ins[i].name === earlyPick.name && ins[i].value === earlyPick.value) { input = ins[i]; break; }
        }
        if (!input || input.disabled) { finish(false); return; }
        /* Et rigtigt klik: temaet og Choose size ser det som kundens valg. Er knappen allerede valgt, sendes change. */
        if (!input.checked) input.click();
        else input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      function onVariant(e) {
        var vr = findVr();
        if (!vr || !e.target || (e.target !== vr && !vr.contains(e.target))) return;
        var v = e.detail && e.detail.variant;
        setTimeout(function () {
          if (matches(v)) finish(true);
          else if (tries < 3) attempt();
          else finish(false);
        }, 0);
      }
      document.addEventListener('on:variant:change', onVariant, true);
      timer = setTimeout(function () { finish(false); }, SYNC_WAIT);
      attempt();
    }

    function syncReady() {
      if (!earlyPick) return true;
      if (sync === 'none') startSync();
      return sync === 'done';
    }

    function dropSubmit() {
      pendingSubmit = null;
      clearTimeout(submitTimer);
    }

    function tryReplaySubmit() {
      var p = pendingSubmit;
      if (!p || !dclDone) return;
      if (earlyPick && sync === 'failed') { dropSubmit(); return; }
      if (!syncReady()) return;
      var idIn = formOf(p).querySelector('input[name="id"]');
      if (idIn && idIn.disabled) return;
      dropSubmit();
      setTimeout(function () {
        try { submitForm(p); } catch (err) { warn(err); }
        tick();
      }, 0);
    }

    function giveUpSubmit(p) {
      if (pendingSubmit !== p) return;
      if (stillLoading() || sync === 'pending') {
        submitTimer = setTimeout(function () { giveUpSubmit(p); }, 500);
        return;
      }
      /* Uden product-form eller med et valg der ikke naaede variant-id'et, sendes intet. Hellere et tabt tryk end en forkert vare. */
      if (!customElements.get('product-form') || (earlyPick && sync !== 'done')) {
        dropSubmit();
        tick();
        return;
      }
      dropSubmit();
      try {
        var idIn = formOf(p).querySelector('input[name="id"]');
        if (idIn) idIn.removeAttribute('disabled');
        submitForm(p);
      } catch (err) { warn(err); }
      tick();
    }

    function tick() {
      try {
        if (earlyPick && sync === 'none' && dclDone) startSync();
        tryReplayClick();
        tryReplaySubmit();
        if (!pendingClick && !pendingSubmit && allBound() && sync !== 'pending' && !(earlyPick && sync === 'none')) teardown();
      } catch (err) { warn(err); }
    }

    function onClick(e) {
      try {
        if (e.__twrdReplay) return;
        if (e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        var t = e.target && e.target.closest ? e.target.closest('[data-a11y-dialog-show]') : null;
        if (!t) return;
        var id = t.getAttribute('data-a11y-dialog-show');
        var dlg = document.getElementById(id);
        if (dlg && dlg.getAttribute('aria-modal') === 'true') return;
        /* Kun modal-dialog (menu, kurv). Soeg og popups har egne scripts og roeres ikke. */
        if (dlg ? dlg.tagName !== 'MODAL-DIALOG' : (id !== MENU && id !== CART)) return;
        if (!dlg && document.readyState === 'complete') return;
        e.preventDefault();
        var p = { el: t, id: id };
        pendingClick = p;
        clearTimeout(clickTimer);
        clickTimer = setTimeout(function () { giveUpClick(p); }, CLICK_WAIT);
      } catch (err) { warn(err); }
    }

    function onSubmit(e) {
      try {
        var f = e.target;
        if (!f || f.__twrdReplay || !f.closest || !f.closest('product-form')) return;
        var idIn = f.querySelector('input[name="id"]');
        if (!idIn || !idIn.disabled) return;
        e.preventDefault();
        e.stopPropagation();
        var p = { form: f, formId: f.getAttribute('id') || '', submitter: e.submitter || null };
        pendingSubmit = p;
        clearTimeout(submitTimer);
        submitTimer = setTimeout(function () { giveUpSubmit(p); }, SUBMIT_WAIT);
      } catch (err) { warn(err); }
    }

    /* Stoerrelse eller farve valgt foer variant-radios er klar: husk valget. */
    /* Stoerrelse eller farve trykket foer variant-radios er klar: knappen skifter ikke nu.
       Et tidligt skift goer temaets variant-cache forkert (L viser S). Trykket gemmes og afspilles naar temaet er klar. */
    function onPick(e) {
      try {
        if (!e.isTrusted || customElements.get('variant-radios')) return;
        var t = e.target;
        if (!t || !t.closest || !t.closest('variant-radios')) return;
        var l = t.closest('label');
        var input = l && l.control ? l.control : (t.type === 'radio' ? t : null);
        if (!input || input.type !== 'radio' || input.disabled || !input.closest('variant-radios')) return;
        e.preventDefault();
        if (!earlyPick && customElements.whenDefined) {
          customElements.whenDefined('variant-radios').then(function () { setTimeout(tick, 0); });
        }
        earlyPick = { name: input.name, value: input.value };
      } catch (err) { warn(err); }
    }

    window.addEventListener('click', onClick, true);
    window.addEventListener('submit', onSubmit, true);
    window.addEventListener('click', onPick, true);
    document.addEventListener('DOMContentLoaded', onDcl);
    window.addEventListener('load', tick);
    mo = new MutationObserver(tick);
    mo.observe(document.documentElement, { attributes: true, subtree: true, attributeFilter: ['aria-modal', 'disabled'] });
  } catch (err) {
    try { console.warn('TWRD: early-tap', err); } catch (_) {}
  }
})();
